import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useParams, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { ShopProvider } from "./context/ShopContext";
import StoreLayout from "./components/store/StoreLayout";
import AdminLayout from "./components/admin/AdminLayout";
import Home from "./pages/store/Home";
import Shop from "./pages/store/Shop";
import Product from "./pages/store/Product";
import Checkout from "./pages/store/Checkout";
import OrderSuccess from "./pages/store/OrderSuccess";
import Auth, { AuthCallback } from "./pages/store/Auth";
import Account from "./pages/store/Account";
import { CmsPage, Contact, TrackOrder } from "./pages/store/Info";
import Dashboard from "./pages/admin/Dashboard";
import Products from "./pages/admin/Products";
import ProductForm from "./pages/admin/ProductForm";
import { Categories, Media } from "./pages/admin/Catalog";
import Orders from "./pages/admin/Orders";
import { Customers, Coupons } from "./pages/admin/Commerce";
import Content from "./pages/admin/Content";
import Leads, { LeadDetail } from "./pages/admin/Leads";
import Chatbot from "./pages/admin/Chatbot";
import { Team, Inbox } from "./pages/admin/System";

const ProductFormKeyed = () => { const { id } = useParams(); return <ProductForm key={id} />; };

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<StoreLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/:slug" element={<Shop />} />
        <Route path="/product/:slug" element={<Product />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/order/:id" element={<OrderSuccess />} />
        <Route path="/login" element={<Auth mode="login" />} />
        <Route path="/register" element={<Auth mode="register" />} />
        <Route path="/forgot-password" element={<Auth mode="forgot" />} />
        <Route path="/reset-password" element={<Auth mode="reset" />} />
        <Route path="/account" element={<Account />} />
        <Route path="/page/:slug" element={<CmsPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/track-order" element={<TrackOrder />} />
        <Route path="*" element={<div className="container-x py-24"><h1 className="text-4xl text-[#1B3B2B]">Page not found</h1></div>} />
      </Route>
      <Route path="/admin/login" element={<Auth mode="login" admin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="products" element={<Products />} />
        <Route path="products/:id" element={<ProductFormKeyed />} />
        <Route path="categories" element={<Categories />} />
        <Route path="media" element={<Media />} />
        <Route path="orders" element={<Orders />} />
        <Route path="customers" element={<Customers />} />
        <Route path="coupons" element={<Coupons />} />
        <Route path="content" element={<Content />} />
        <Route path="leads" element={<Leads />} />
        <Route path="leads/:id" element={<LeadDetail />} />
        <Route path="chatbot" element={<Chatbot />} />
        <Route path="team" element={<Team />} />
        <Route path="inbox" element={<Inbox />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ShopProvider>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </ShopProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
